import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RefundFlowEndPoints} from 'main/factories/usecases';
import {GetSearchRefund} from 'domain/usecases';
import {RemoteGetSearchRefund} from 'data/usecases';

export const makeGetSearchRefund = (): GetSearchRefund =>
	new RemoteGetSearchRefund(
		makeBFFApiUrl(RefundFlowEndPoints.additionalDocumentsSearch),
		makeAuthorizeHttpClientDecorator(),
	);
